import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ParamMap } from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { List } from '../models/list.model';
import { map, switchMap, tap } from 'rxjs/operators';
import { Event } from '../models/event.model';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor(
    private http: HttpClient
  ) { }

  getEvents(zajla = false, vip = false) {

    
    let url = environment.apiUrl + '/providers/436/events';

    const today = new Date();
    const todayISOStr = today.toISOString().split('T')[0];

    let commonQueryString = `?expand=spots&start=${todayISOStr}&sortOrder=asc&pageSize=100&sortBy=start`;

    const responseToModel = ( response: any): any =>  {

      if ( response._embedded && response._embedded.eventbyprovider  ) {
          return response._embedded.eventbyprovider.map( eventData => new Event( eventData) ).filter(event => {
            return event.spots > 0 && event.status >= 20 && event.start > moment().format()  && ( zajla && event.name.includes('zajl') || (!zajla && !event.name.includes('zajl') && ((vip && event.name.includes('Giro')) || (!vip && !event.name.includes('Giro')))))
          });
      } else {
        return [];
      }

    } 

    return this.http.get( url + commonQueryString ).pipe(
      map( response => responseToModel( response ) )
    );

    //result.subscribe( data => console.log( data ) );

  }

  getEventById( providerId: string | number, eventId: string | number ): Observable<Event> {

    const endpointUrl = `${environment.apiUrl}/providers/${providerId}/events/${eventId}?expand=spots`;
    return this.http.get(endpointUrl).pipe(
      map(response => new Event(response))
    );

  }


}